// import { createStore, applyMiddleware, compose } from 'redux';
// import thunk from 'redux-thunk';
// import reducers from './reducers';

// const initialState = {};
// const enhancers = [];
// const middleware = [thunk];

// if (process.env.NODE_ENV === 'development') {
//   const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

//   if (typeof devToolsExtension === 'function') {
//     enhancers.push(devToolsExtension());
//   }
// }

// const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);
// const store = createStore(reducers, initialState, composedEnhancers);

// export default store;

import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';

const initialState = {};
const store = createStore(
  reducers,
  initialState,
  applyMiddleware(thunk)
);

export default store;


// WEBPACK FOOTER //
// ./src/Store.js